import _ from 'lodash';

export const isAdresseEmpty = (adresse) => {
  if (_.isNil(adresse)) {
    return true;
  }

  if (
    adresse &&
    _.isEmpty(adresse.numeroCodePostal) &&
    _.isEmpty(adresse.lettre) &&
    _.isEmpty(adresse.numeroVoirie) &&
    _.isEmpty(adresse.libellePays) &&
    _.isEmpty(adresse.libelleVoie)
  ) {
    return true;
  }

  return false;
};
